import { useEffect, useRef, useState } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { Card, Checkbox, Button, Popover, Typography, Row } from 'antd'
import { Check, Edit, X } from 'react-feather'
import { setDevtoolsEnabled } from 'Actions/graph'
import { setConfigEnabled } from 'Actions/projects'
import { setHideChangelog } from 'Actions/explore'
{ Paragraph, Text } = Typography


helpText = (<div style={{ width: 500, lineHeight: '1.6rem' }}>
  <Paragraph>
    Enables the devtools console in the graph view. This console can be used to write and execute queries directly against the server, and have the results shown in the graph view.
    Some helpers for query syntax are available there.
  </Paragraph>
  <Text type="secondary">
    Shortcuts:
    <ul>
      <li>
        Toggle the graph console with Ctrl + D, or Cmd + D
      </li>
      <li>
        Close the graph console with Esc
      </li>
      <li>
        Execute the query in the console with Ctrl + Enter, or Cmd + Enter
      </li>
    </ul>
  </Text>
</div>)

info = (
  <Popover
    content={helpText}
    title='Developer Mode'
    trigger="click"
    placement="left"
  >
    <a><QuestionCircleOutlined /></a>
  </Popover>
)

DevtoolsPanel = ({ devtoolsEnabled, setDevtoolsEnabled, displayConfigEnabled, setConfigEnabled, hideChangelog, setHideChangelog }) ->

  useEffect( ->
    if displayConfigEnabled
      Weaver.Query.setHiddenGraphs([])
    else
      Weaver.Query.setHiddenGraphs(['$config'])
    undefined
  , [displayConfigEnabled])

  <Card
    title="Developer mode"
    extra={info}
    size="small"
    id="Developer mode"
  >
    <Row>
      <Checkbox
        style={{ marginRight: 5 }}
        onChange={({ target: { checked } }) ->
          setDevtoolsEnabled(checked)
        }
        checked={devtoolsEnabled}
      />
      Enable the developer console in the graph view?
    </Row>
    <Row>
      <Checkbox
        style={{ marginRight: 5 }}
        onChange={({ target: { checked } }) ->
          setConfigEnabled(checked)
        }
        checked={displayConfigEnabled}
      />
      Display config data within the space?
    </Row>
    <Row>
      <Checkbox
        data-testid='hide-changelog'
        style={{ marginRight: 5 }}
        onChange={({ target: { checked } }) ->
          setHideChangelog(checked)
        }
        checked={hideChangelog}
      />
      Hide Changelog
    </Row>
  </Card>

export default connect(({ graph, projects, explore }) ->
  {
    devtoolsEnabled: graph.devtoolsEnabled
    displayConfigEnabled: projects.displayConfigEnabled
    hideChangelog: explore.hideChangelog
  }
, {
  setDevtoolsEnabled,
  setConfigEnabled,
  setHideChangelog
  })(DevtoolsPanel)
